<template>
  <div :class="$style.regionDropdownWrapper" class="custom-dropdown">
    <GlobeIcon width="100%" />
    <select
      class="regionDropdown"
      name="region"
      v-model="selectedRegion"
      @change="onchange()"
      aria-label="country selector"
    >
      <option v-for="(option, index) in options" :key="index" :value="option.code">
        {{ option.name }}
      </option>
    </select>
  </div>
</template>

<script>
import GlobeIcon from './GlobeIcon'
import { redirectStore } from '../../util/redirectStore'
import { regions } from '../../constants.js'

export default {
  name: 'regionDropdown',
  components: {
    GlobeIcon,
  },
  data() {
    return {
      selectedRegion: REGION,
      options: regions,
    }
  },
  methods: {
    onchange: function () {
      const currentStore = regions[REGION]
      const targetStore = regions[this.selectedRegion]

      // url suffix :  ?ref=CURRENTSTORE_store_dropdown
      redirectStore(targetStore, currentStore, 'dropdown')
    },
  },
}
</script>
<style module>
.regionDropdownWrapper {
  display: inline-flex;
  align-items: center;
  margin-left: 15px;
}
.regionDropdownWrapper svg {
  margin-right: 8px;
  max-width: 12px;
}
.regionDropdownWrapper select {
  text-transform: uppercase;
  color: #191919;
  font-weight: 500;
  line-height: 1;
  padding-top: 2px;
  padding-bottom: 2px;
}
</style>
